module.exports = __webpack_public_path__ + "static/banner_vestibular_2025_2-d050d8fcdd11254d9d5e02bdf9af77cc.jpg";